import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import OrdersPage from "@/pages/OrdersPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminOrdersPage from "@/pages/AdminOrdersPage";
import AdminWaitlistPage from "@/pages/AdminWaitlistPage";
import AdminPreordersPage from "@/pages/AdminPreordersPage";
import AdminEmailsPage from "@/pages/AdminEmailsPage";
import ContactPage from "@/pages/ContactPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AdminVisitorsPage from "@/pages/AdminVisitorsPage";
import AdminCouponsPage from "@/pages/AdminCouponsPage";
import AdminReviewsPage from "@/pages/AdminReviewsPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import AdminCategoriesPage from "@/pages/AdminCategoriesPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminShowcasePage from "@/pages/AdminShowcasePage";
import DesignRequestPage from "@/pages/DesignRequestPage";
import AdminDesignRequestsPage from "@/pages/AdminDesignRequestsPage";
import AdminSiteContentPage from "@/pages/AdminSiteContentPage";
import VisitorTracker from "@/components/VisitorTracker";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <VisitorTracker />
      <AuthProvider>
        <CartProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:id" element={<ProductDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/orders" element={<AdminOrdersPage />} />
              <Route path="/admin/waitlist" element={<AdminWaitlistPage />} />
              <Route path="/admin/preorders" element={<AdminPreordersPage />} />
              <Route path="/admin/emails" element={<AdminEmailsPage />} />
              <Route path="/admin/visitors" element={<AdminVisitorsPage />} />
              <Route path="/admin/coupons" element={<AdminCouponsPage />} />
              <Route path="/admin/reviews" element={<AdminReviewsPage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/admin/categories" element={<AdminCategoriesPage />} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/users/:id" element={<AdminUsersPage />} />
              <Route path="/admin/showcase" element={<AdminShowcasePage />} />
              <Route path="/design-request" element={<DesignRequestPage />} />
              <Route path="/admin/design-requests" element={<AdminDesignRequestsPage />} />
              <Route path="/admin/site-content" element={<AdminSiteContentPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
            </Routes>
          </Layout>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
